/* unplugin-vue-components disabled */import script from "./StudentsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentsTable.vue?vue&type=script&setup=true&lang=js"

import "./StudentsTable.vue?vue&type=style&index=0&id=4d2e361f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d2e361f"]])

export default __exports__